import { useState, useCallback, useEffect } from 'react';
import { StoreSettings } from '../Types/StoreTypes';

export const useThemeSettings = (Currentsettings: StoreSettings, SettingsActions: any) => {
    const [imagePreviewDark, setImagePreviewDark] = useState<string | null>(null);
    const [imagePreviewLight, setImagePreviewLight] = useState<string | null>(null);

    const handleImageChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>, themeColor: string) => {
            if (e.target.files && e.target.files[0]) {
                const file = e.target.files[0];

                if (themeColor === 'light') {
                    setImagePreviewLight(URL.createObjectURL(file));
                    SettingsActions.setCurrentSettings((prev: any) => {
                        return {
                            ...prev,
                            theme: { ...prev.theme, lightThemeImage: file },
                        };
                    });
                } else {
                    setImagePreviewDark(URL.createObjectURL(file));

                    SettingsActions.setCurrentSettings((prev: any) => {
                        return {
                            ...prev,
                            theme: { ...prev.theme, darkThemeImage: file },
                        };
                    });
                }
            }
        },

        [setImagePreviewLight, setImagePreviewDark, SettingsActions],
    );

    const handleRemoveImage = useCallback((themeColor: string) => {
        if (themeColor === 'light') {
            setImagePreviewLight(null);

            SettingsActions.setCurrentSettings((prev: any) => {
                return {
                    ...prev,

                    theme: { ...prev.theme, lightThemeImage: null },
                };
            });
        } else {
            setImagePreviewDark(null);

            SettingsActions.setCurrentSettings((prev: any) => {
                return {
                    ...prev,

                    theme: { ...prev.theme, darkThemeImage: null },
                };
            });
        }
    }, []);

    useEffect(() => {
        setImagePreviewLight(
            Currentsettings.theme.lightThemeImage
                ? typeof Currentsettings.theme.lightThemeImage === 'string'
                    ? Currentsettings.theme.lightThemeImage
                    : URL.createObjectURL(Currentsettings.theme.lightThemeImage)
                : '',
        );

        setImagePreviewDark(
            Currentsettings.theme.darkThemeImage
                ? typeof Currentsettings.theme.darkThemeImage === 'string'
                    ? Currentsettings.theme.darkThemeImage
                    : URL.createObjectURL(Currentsettings.theme.darkThemeImage)
                : '',
        );
    }, [Currentsettings, SettingsActions]);

    return {
        setImagePreviewDark,
        setImagePreviewLight,
        handleImageChange,
        handleRemoveImage,
        imagePreviewDark,
        imagePreviewLight,
    };
};
